import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';
import FMSToolbar from 'src/common/FMSToolbar';
import FilterSelectInput from 'src/common/FilterSelectInput';
import NewDriver from 'src/components/drivers/NewDriver';
import DriverListTable from 'src/components/drivers/DriverListTable';
import ScreenHeader from 'src/common/ScreenHeader';
import useAdminSiteFilter from 'src/hooks/useAdminSiteFilter';
import usePersistentListFilters from 'src/hooks/usePersistentListFilters';

const Drivers = ({ location }) => {
  const {
    search, site, setSearch, setSite
  } = usePersistentListFilters();
  const {
    isAdmin,
    siteFilter,
    setSiteFilter,
    siteOptions
  } = useAdminSiteFilter(site);
  const [openModal, setOpenModal] = useState(false);
  const [searchText, setSearchText] = useState(search);
  const [searchFilters, setSearchFilters] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSearch = (str) => { setSearchText(str); setSearch(str); };

  return (
    <>
      <ScreenHeader title="Drivers" />
      <Box
        className="transaction-style-page"
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <FMSToolbar
            placeholder="Search Driver Name"
            actionName="Add Driver"
            searchValue={searchText}
            searchFields={[
              { key: 'user__first_name', label: 'First Name', defaultChecked: true },
              { key: 'user__last_name', label: 'Last Name' },
              { key: 'mobile_num', label: 'Phone' }
            ]}
            searchValues={searchFilters}
            onSearchFields={(values) => { setSearchFilters(values); setSearchText(''); setSearch(''); }}
            onClearSearchFields={() => { setSearchFilters({}); setSearchText(''); setSearch(''); }}
            onSearch={handleSearch}
            onAction={() => setOpenModal(true)}
            onRefresh={() => setRefreshKey((value) => value + 1)}
          >
            {isAdmin && (
              <FilterSelectInput
                label="Site"
                name="site"
                value={siteFilter}
                data={siteOptions}
                onInputChange={(value) => { setSiteFilter(value); setSite(value); }}
                sx={{ width: { xs: '100%', sm: 220, md: 180 }, mr: 0 }}
              />
            )}
          </FMSToolbar>
          <NewDriver open={openModal} handleClose={() => setOpenModal(false)} />
          <Box sx={{ pt: 3 }}>
            <DriverListTable
              refreshData={refreshKey || location.state?.fromDashboard}
              searchText={searchText}
              searchFilters={searchFilters}
              siteFilter={siteFilter}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

Drivers.propTypes = {
  location: PropTypes.object
};

export default Drivers;
